import { useNotificationsAdapterPriceListSync } from "./price-list-sync";
import { useNotificationsAdapterPrices } from "./prices";

/**
 * Mounts the set of notification adapters that observe producer collections
 * synced via RxDB. Each adapter is a hook that calls `notifications.emit` /
 * `recall` reactively (ADR-004 §6).
 *
 * Adapters live in producer domains — not in the notifications system — so
 * the notification system has no awareness of them. The notification system
 * never imports this file; this component mounts on the rxdb-provider side
 * of the tree, where the producer collections live.
 */
export const RxDBNotificationsAdapters = () => {
  useNotificationsAdapterPrices();
  useNotificationsAdapterPriceListSync();
  return null;
};
